import React from 'react';

const LoaderExparel = ({ className = '', size = '50px', color = '#165F57', animation = '1s' }) => {
    const loaderStyle = {
        width: size,
        aspectRatio: '1',
        borderRadius: '50%',
        background: `radial-gradient(farthest-side,${color} 94%,#0000) top/8px 8px no-repeat,
      conic-gradient(#0000 30%,${color})`,
        WebkitMask: 'radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0)',
        animation: `l13 ${animation} infinite linear`
    }

    const keyframesStyle = `
        @keyframes l13 { 
            100% { transform: rotate(1turn) }
        }
    `;

    return (
        <>
            <style>{keyframesStyle}</style>
            <div className={`loader ${className}`} style={loaderStyle} aria-label="Loading" role="status"></div>
        </>
    );
};

export default LoaderExparel;